module.exports = __webpack_public_path__ + "static/media/image-004.9f21693c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-004.jpeg
// module id = 780
// module chunks = 0